import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { lloydConstants } from '../Constants';

export const NO_COMPARISON = 'None';

const defaultValues = {
	selectedYear: null,
	setSelectedYear: () => {},
	comparisonYear: NO_COMPARISON,
	setComparisonYear: () => {},
	yearlyData: {},
	setYearlyDataForYear: () => {},
	loadedYears: [],
};

const YearContext = createContext(defaultValues);

export const YearProvider = ({ children }) => {
	// Read at render, not at import: the wave list comes from data/waves.json and is
	// only in place once the bootstrap in index.js has fetched it. Newest wave first,
	// so waves[0] is the default view and waves[1] the wave before it.
	const [latestWave, previousWave] = lloydConstants.waves;

	const [selectedYear, setSelectedYear] = useState(latestWave);
	const [comparisonYear, setComparisonYear] = useState(previousWave ?? NO_COMPARISON);
	const [yearlyData, setYearlyData] = useState({});

	// Stable identity: useData keys its fetch effect on this.
	const setYearlyDataForYear = useCallback((year, rows) => {
		setYearlyData((previous) => ({ ...previous, [year]: rows }));
	}, []);

	const loadedYears = useMemo(() => Object.keys(yearlyData).map(Number), [yearlyData]);

	const value = useMemo(
		() => ({ selectedYear, setSelectedYear, comparisonYear, setComparisonYear, yearlyData, setYearlyDataForYear, loadedYears }),
		// Stable identity: the chart's draw effect depends on this object, and a new
		// one every render would rebind and re-transition every shape.
		[selectedYear, setSelectedYear, comparisonYear, setComparisonYear, yearlyData, setYearlyDataForYear, loadedYears]
	);

	return <YearContext.Provider value={value}>{children}</YearContext.Provider>;
};

export const useYearContext = () => useContext(YearContext);
